//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AssetOmLogModal from "./modules/AssetOmLogModal";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: "AssetOmLogList",
  mixins: [JeecgListMixin],
  components: {
    AssetOmLogModal: AssetOmLogModal
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/om/log',
      pageTitle: '资产运维台账',
      userTree: [],
      //人员信息
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: "center"
      }, {
        dataIndex: 'productName',
        title: '产品名称',
        align: "center"
      }, {
        dataIndex: 'productCode',
        title: '产品编号',
        align: "center"
      }, {
        dataIndex: 'productCategory_dictText',
        title: '产品类型',
        align: "center"
      }, {
        dataIndex: 'quantity',
        title: '数量',
        align: "center"
      }, {
        dataIndex: 'quantityUnit_dictText',
        title: '计量单位',
        align: "center"
      }, {
        dataIndex: 'purpose_dictText',
        title: '用途',
        align: "center"
      }, {
        dataIndex: 'eventType_dictText',
        title: '事件类型',
        align: "center"
      }, {
        dataIndex: 'createBy_userName',
        title: '操作人',
        align: "center"
      }, {
        dataIndex: 'operationTime',
        title: '运维时间',
        align: "center"
      }, {
        dataIndex: 'createTime',
        title: '操作时间',
        align: "center"
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  computed: {},
  methods: {
    onOperationDateDate: function onOperationDateDate(value, dateArray) {
      this.queryParam.dateStart = dateArray[0];
      this.queryParam.dateEnd = dateArray[1];
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleDetail: function handleDetail(record) {
      this.$refs.assetOmLogModal.show(record);
    }
  }
};